import { Alignment, BoxModelConstraint, CellPanel, CellRenderer, DotRenderer, RowPanel, SquareRenderer, StaticParagraphComponent } from '@blk/simba';
import { ColorsConfig } from '@ddt-web/config';
import { CellData } from '@ddt-web/data-service';

export class PortfolioDotRenderer implements CellRenderer {
	constructor(
		private cell: CellData,
		private index: number,
		private hAlign: Alignment.Horizontal,
		private widthProportion: number,
		private textClasses?: Array<string>,
		private constraints?: Partial<BoxModelConstraint>,
		private dotSize = 10,
		private portfolioColors?: string[],
		private dotStyling: 'dot' | 'line' = 'dot'
	) { }

	public render(): CellPanel {
		const text = this.cell && this.cell.formattedValue;
		let dotRenderer;
		switch (this.dotStyling) {
			case 'line':
				dotRenderer = new SquareRenderer(this.portfolioColors?.[this.index] || ColorsConfig.PORTFOLIO_COLORS[this.index], { paddingRight: 10, paddingTop: 5 }, this.dotSize, 1);
				break;
			case 'dot':
			default:
				dotRenderer = new DotRenderer(this.portfolioColors?.[this.index] || ColorsConfig.PORTFOLIO_COLORS[this.index], { paddingRight: 10 }, { size: this.dotSize });
				break;
		}
		return new CellPanel(
			[
				new RowPanel(
					'port name',
					[
						dotRenderer,
						new StaticParagraphComponent(null, text, {}, BoxModelConstraint.merge(this.constraints), this.textClasses)
					],
					{},
					Alignment.Horizontal.Left
				)
			],
			{ proportion: this.widthProportion },
			this.hAlign
		);
	}
}
